import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// The state kept by the premade answer inserter.

// Initial premade answer inserter state.
export var getInitialPremadeAnswerInserterState = function getInitialPremadeAnswerInserterState() {
  return {
    open: false
  };
};

// Function to calculate the premade answer inserter state based upon the message
// input text area.
export var getNextPremadeAnswerInserterState = function getNextPremadeAnswerInserterState(currentState, input) {
  // Ensure it starts with a `/`.
  var message = input.value;
  if (!message.startsWith('/')) {
    return {
      open: false
    };
  }

  // Ensure there's at most a single word after it.
  var cursorPosition = input.selectionStart;
  var words = message.slice(1, cursorPosition).split(/\s+/);
  if (words.length > 1) {
    return {
      open: false
    };
  }

  // Candidate for the premade answer inserter.
  return _objectSpread(_objectSpread({}, currentState), {}, {
    open: true,
    filter: words[0]
  });
};

// This is called when there is a keystroke in the message input, and gives the mention inserter
// chance to process or act upon it. Returns true if there should be no further processing.
export var offerKeyEventToPremadeAnswerInserter = function offerKeyEventToPremadeAnswerInserter(event, state, updateState, updateMessage, substitutePlaceholders) {
  // If it's not open or there's no proposed insertion, nothing to do.
  if (!state.open || !state.proposedInsertion) {
    return false;
  }

  // Otherwise, go by key.
  switch (event.key) {
    case 'Enter':
      {
        // Insert the premade answer and close.
        insertPremadeAnswer(substitutePlaceholders(state.proposedInsertion.message), updateState, updateMessage);
        event.preventDefault();
        return true;
      }
    case 'Escape':
      {
        // Close the answer inserter.
        updateState({
          open: false
        });
        return true;
      }
    case 'ArrowUp':
      {
        updateState(_objectSpread(_objectSpread({}, state), {}, {
          insertionOffset: state.insertionOffset - 1
        }));
        event.preventDefault();
        return true;
      }
    case 'ArrowDown':
      {
        updateState(_objectSpread(_objectSpread({}, state), {}, {
          insertionOffset: state.insertionOffset + 1
        }));
        event.preventDefault();
        return true;
      }
  }
  return false;
};
export var insertPremadeAnswer = function insertPremadeAnswer(premadeAnswer, updateState, updateMessage) {
  updateMessage(premadeAnswer, premadeAnswer.length);
  updateState({
    open: false
  });
};